import { useMutation } from "react-query";
import api from "../../client";
import { AuthSetPasswordPayload } from "../../types/auth";

const postData = async (payload: AuthSetPasswordPayload): Promise<[]> => {
  const { data } = await api.post(`/reset-password/new-password`, payload);

  return data;
};

export const useSetPassword = () => {
  return useMutation((payload: AuthSetPasswordPayload) => {
    return postData(payload);
  });
};
